import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { expensesApi } from '../../api/expensesApi'
import type { ExpenseUpdateData } from '../../schema/expensesSchema'
import type { ApiError } from '@/types/api'
import { notifyRequestError } from '@/utils/notifyRequestError'

export const usePublicUpdateExpenseMutation = (token: string, onSuccess?: () => void) =>
  useMutation({
    mutationFn: (expense: ExpenseUpdateData) =>
      expensesApi.updateExpenseByToken(token, expense).then((r) => r.data),
    onSuccess: ({ message }) => {
      toast.success(message || 'Expense updated successfully.')
      onSuccess?.()
    },
    onError: (error: ApiError) => {
      notifyRequestError(error, 'An error occurred while updating the expense.')
    },
  })
